export default "__VITE_ASSET__BF1Q_SfN__"